import { Grid } from '@mui/material';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { StyledTextareaInput } from '../../styled/textarea.input';
import { FieldInputBuilderType } from '../field.input.builder.type';

export const TextareaInput = ({
  field,
  design,
  urlValue,
  onChange,
  value,
  focus,
  error,
  helperText,
}: any) => {
  const { t } = useTranslation();

  // let initialValue = undefined;

  // if (field.defaultValue) {
  //   try {
  //     initialValue = parseValue(field.defaultValue);
  //   } catch (e) {
  //     console.log('invalid default value', e);
  //   }
  // }

  // if (urlValue) {
  //   initialValue = parseUrlValue(urlValue);
  // }

  return (
    <Grid>
      <StyledTextareaInput
        design={design}
        onChange={onChange}
        value={value !== null ? value : ''}
        name={field.id}
        id={field.id}
        multiline={field.type === 'textarea'}
        error={error !== undefined ? true : false}
        helperText={error}
        variant={'standard'}
        type={field.type}
        field={field}
        $disableUnderline={field.type === 'textarea'}
        minRows={5}
        // required={field.required} // not sure if we want this here, uncomment if we don't want the MUI helpertext
      />
    </Grid>
  );
};
